import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { zGetResidentRestContractsByContractUuidRightOfOccupancyFeeResponse as contractRightOfOccupancyFeeResponseSchema } from '../../../common/generated/residentApiSchemas'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

import { get } from 'api/apiClient'

const rightOfOccupancyFeeSchema = z.object({
  rightOfOccupancyFee: contractRightOfOccupancyFeeResponseSchema.shape.data,
})

const rightOfOccupancyFeeQuery = (contractUuid: string) => {
  const endpoint = `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/right-of-occupancy-fee`

  return {
    queryKey: [endpoint],
    queryFn: async () =>
      (await get(endpoint, rightOfOccupancyFeeSchema)).rightOfOccupancyFee,
  }
}

export const useAPIGetContractRightOfOccupancyFee = (
  contractUuid: string,
  enabled: boolean
) =>
  useQuery({
    ...rightOfOccupancyFeeQuery(contractUuid),
    enabled,
    throwOnError: false,
  })

export const useAPIGetContractRightOfOccupancyFeeSuspense = (
  contractUuid: string
) => useSuspenseQuery(rightOfOccupancyFeeQuery(contractUuid))
